import React from "react";
import InterceptorNodePanel from "./InterceptorNodePanel";
import AgencyRevenueLoopPanel from "./AgencyRevenueLoopPanel";

const HowItWorksSection = () => (
  <section id="how-it-works" className="section-padding section-alt relative overflow-hidden" data-testid="how-it-works">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
      <div className="mb-16 sm:mb-20">
        <InterceptorNodePanel />
      </div>
      <AgencyRevenueLoopPanel />
    </div>
  </section>
);

export default HowItWorksSection;
